import React from "react";

import { TicketItem } from "../../../../contexts/ticket-state";
import Badge from "../../../theme/badge/Badge";

export default function Queue({ ticket }: {
    ticket: TicketItem
}) {
    return (
        <Badge variant="success">
            {ticket.ticket?.queue?.name}
        </Badge>
    );
}
